<template>
  <div key="cover">
    <img
      :src="classRoomPhoto"
      alt="content-img"
      class="responsive card-img-top"
    />
  </div>
</template>

<script>
import {getClassRoomUrl} from "@/utils/upload";

export default {
  props:[
    'classSection'
  ],
  computed:{
    classRoomPhoto() {
      let url = '';
      if(this.classSection){
        url = this.classSection.courseOutlineRegistration.courseOutline.picturePath
      }
      return getClassRoomUrl(url);
    }
  }
}
</script>

<style>

</style>
